import { Navigate } from "react-router";
import { useAuth } from "@/auth/AuthContext";

export function RootRedirect() {
  const { user } = useAuth();

  if (!user?.orgId) {
    return (
      <p className="relative text-foreground">
        No organization found for this account.
      </p>
    );
  }

  return <Navigate to={`/${user.orgId}`} replace />;
}
